import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Button } from '@components/button';
import { IconTrash } from '@components/icons/trash';
import { Text } from '@components/text';
import { useToaster } from '@components/toaster';

import { api } from 'api';
import { Modal } from 'features/modals';
import { useStore } from 'models/Provider';

type Props = {
  clientId: string;
  closeModal: () => void;
};

export const DeleteUserAppModal = (props: Props) => {
  const { t } = useStore();
  const { clientId, closeModal } = props;
  const { showSuccess } = useToaster();

  const queryClient = useQueryClient();
  const submit = useMutation(() => api.users.removeApp(clientId), {
    onSuccess: () => {
      queryClient.invalidateQueries(['userApps']);
      showSuccess(t('modals.deleteuserapp.success'));
      closeModal();
    },
  });

  return (
    <Modal>
      <Modal.Header text={t('modals.deleteuserapp.header')} />
      <Text text={t('modals.deleteuserapp.content')} />
      <Text color="red100" text={t('modals.deleteuserapp.undone')} />
      <Modal.Actions>
        <Button variant="secondary" onClick={closeModal} text={t('modals.deleteuserapp.cancel')} />
        <Button
          iconLeft={<IconTrash />}
          variant="primary-red"
          isDisabled={submit.isLoading}
          onClick={() => submit.mutate()}
          text={t('modals.deleteuserapp.save')}
        />
      </Modal.Actions>
    </Modal>
  );
};
